import { userAuthRequests } from "@/src/api/userInfoRequests";
import "./style.scss";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { AppDispatch } from "@/src/store";
import { setActualUserConfig } from "@/src/store/slices/UserOptions/userOptionsSlice";
import { setSidebarConfig } from "@/src/store/slices/SideBarMenu/SideBarMenuSlice";
import { setVisibleColumns as setAOPVisibleColumns } from "@/src/store/slices/ApplicationPage/applicationsTableSlice";
import { setVisibleColumns as setAODPVisibleColumns } from "@/src/store/slices/AdmissionOfficeDatabase/AODatabaseTableSlice";
import { setVisibleColumns as setTOPVisibleColumns } from "@/src/store/slices/TasksPage/tasksTableSlice";
import { setVisibleColumns as setOAPVisibleColumns } from "@/src/store/slices/OfficeAccountingPage/officeAccountingTableSlice";
import { saveUserConfigToStorage } from "@/src/utils/userConfigStorage";
import { normalizeVisibleAOPColumns } from "@/src/constants/applicationOnlineConsts";
import { normalizeVisibleOAPColumns } from "@/src/constants/officeAccountingTableConfig";
import { normalizeVisibleTOPColumns } from "@/src/constants/tasksTableColumns";

type FormValues = {
  username: string;
  password: string;
};

const LoginForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormValues>();

  const onSubmit = async (data: FormValues) => {
    try {
      const userAuthInfo = await userAuthRequests.singIn(data);
      console.log("userAuthInfo e232132133", userAuthInfo);

      if (userAuthInfo) {
        localStorage.setItem("accessToken", userAuthInfo.access_token);
        localStorage.setItem("userLogin", userAuthInfo.login);
        localStorage.setItem("userRole", userAuthInfo.role);
        localStorage.setItem("userID", JSON.stringify(userAuthInfo.user_id));

        // Если пришла конфигурация с бека - сохраняем в localStorage и обновляем все стора
        if (userAuthInfo.config) {
          console.log(userAuthInfo.config, "userAuthInfo.config");
          const userConfig = userAuthInfo.config as any;
          const normalizedUserConfig = {
            ...userConfig,
            ...(userConfig?.AOPConfig?.AOPTable
              ? {
                  AOPConfig: {
                    ...userConfig.AOPConfig,
                    AOPTable: normalizeVisibleAOPColumns(userConfig.AOPConfig.AOPTable),
                  },
                }
              : {}),
            ...(userConfig?.TOPConfig?.TOPTable
              ? {
                  TOPConfig: {
                    ...userConfig.TOPConfig,
                    TOPTable: normalizeVisibleTOPColumns(userConfig.TOPConfig.TOPTable),
                  },
                }
              : {}),
            ...(userConfig?.OAPConfig?.OAPTable
              ? {
                  OAPConfig: {
                    ...userConfig.OAPConfig,
                    OAPTable: normalizeVisibleOAPColumns(userConfig.OAPConfig.OAPTable),
                  },
                }
              : {}),
          };

          saveUserConfigToStorage(normalizedUserConfig);
          dispatch(setActualUserConfig(normalizedUserConfig));

          // Обновляем sideBarMenuSlice с конфигурацией сайдбара (только list, isOpen берется из localStorage)
          if (userConfig?.SideBarConfig?.list) {
            dispatch(
              setSidebarConfig({
                list: userConfig.SideBarConfig.list,
              }),
            );
          }

          // Обновляем конфигурацию таблицы приложений (AOPConfig)
          if (userConfig?.AOPConfig?.AOPTable) {
            dispatch(setAOPVisibleColumns(normalizedUserConfig.AOPConfig!.AOPTable));
          }

          // Обновляем конфигурацию таблицы базы данных (AODPConfig)
          if (userConfig?.AODPConfig?.AODPTable) {
            dispatch(setAODPVisibleColumns(userConfig.AODPConfig.AODPTable));
          }

          // Обновляем конфигурацию таблицы задач (TOPConfig)
          if (userConfig?.TOPConfig?.TOPTable) {
            dispatch(setTOPVisibleColumns(normalizedUserConfig.TOPConfig!.TOPTable));
          }

          // Обновляем конфигурацию таблицы Office Accounting (OAPConfig)
          if (userConfig?.OAPConfig?.OAPTable) {
            dispatch(setOAPVisibleColumns(userConfig.OAPConfig.OAPTable));
          }
        }
        navigate("/", { replace: true });
      } else {
        console.log("Ошибка авторизации: ответ пустой");
      }
    } catch (error) {
      console.error("Ошибка при входе:", error);
    }
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)} className="login-form">
      <div className="login-form-input">
        <label htmlFor="username">Логин</label>
        <input id="username" type="text" placeholder="Введите логин" {...register("username", { required: "Введите логин" })} />
        {errors.username && <p>{errors.username.message}</p>}
      </div>
      <div className="login-form-input">
        <label htmlFor="password">Пароль</label>
        <input
          id="password"
          type="password"
          placeholder="Введите пароль"
          {...register("password", {
            required: "Введите пароль",
            minLength: {
              value: 6,
              message: "Пароль должен быть не менее 6 символов",
            },
          })}
        />
        {errors.password && <p>{errors.password.message}</p>}
      </div>

      <button className="login-form-button" type="submit">
        Войти
      </button>
    </form>
  );
};

export default LoginForm;
